import { SMSContentDefinition } from 'modules/graphql/types';
import { BottomTooltip } from 'ui/tooltip';
import { SETTINGS_DISPLAY_CONTENT } from '../EditSMS/constants';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';
import { OptOutDisclaimerOptions } from './types';

type Props = {
  isUnderlined?: boolean;
};

export const OptOutDisclaimer = ({ isUnderlined = false }: Props) => {
  const DEFAULT_MESSAGE = "Msg&data rates may apply. Text 'STOP' to quit.";
  const { liveTemplate } = useEditableFieldsContext();
  const smsData = (liveTemplate?.mediumData || {}) as SMSContentDefinition;

  const getToolTipContent = () => {
    const { __typename } = smsData.optOutDisclaimer;

    if (__typename === OptOutDisclaimerOptions.onEverySMS) {
      return SETTINGS_DISPLAY_CONTENT.message.optOutOnAllMessages;
    } else if (__typename === OptOutDisclaimerOptions.onFirstSMS) {
      return SETTINGS_DISPLAY_CONTENT.message.optOutOnFirstMessageOnly;
    }
  };

  return (
    <>
      {smsData.optOutDisclaimer?.message && (
        <BottomTooltip tooltipContent={getToolTipContent()} isUnderlined={isUnderlined}>
          {smsData.optOutDisclaimer.message || DEFAULT_MESSAGE}
        </BottomTooltip>
      )}
    </>
  );
};
